import MetaTags from "react-meta-tags"
import { basePath, withBase, stripBase } from "constants/basePath"
import React, { useState, useEffect } from "react"

import {
  Row,
  Col,
  CardBody,
  Card,
  Alert,
  Container,
  Form,
  Input,
  FormFeedback,
  Label,
  Spinner,
} from "reactstrap"

import PasswordInput from "components/Input/PasswordInput"

import { withRouter, Link, Redirect } from "react-router-dom"

// Formik validation
import * as Yup from "yup"
import { useFormik } from "formik"
import { loginUser } from "../../api"

import { setToken, isTokenValid } from "../../helpers/auth_helpers"
import illustration from "../../assets/images/undraw_finance_re_gnv2.svg"

import useStore from "../../newStore"

import metadata from "metadata"
import { formatVersionLabel } from "helpers/version_helpers"
import userStore from "userStore"
import toastHandler from "toastHandler"

// BDSJEA-130: a donde volver despues de loguearse -- la URL que el usuario
// pidio originalmente, si vino de un redirect por sesion invalida.
// Dos fuentes posibles: state.from (redirect declarativo de Authmiddleware,
// dentro del arbol de React) o el query param ?from= (redirectToLogin del
// interceptor de axios, que corre fuera de React). Devuelve un path con el
// prefijo de base path, listo para window.location.href.
export function resolveRedirectPath(location) {
  const fromState = location?.state?.from
  if (fromState?.pathname) {
    return `${basePath()}${fromState.pathname}${fromState.search || ""}`
  }

  const params = new URLSearchParams(location?.search || "")
  const fromQuery = params.get("from")
  if (fromQuery && !fromQuery.includes("iniciar-sesion")) {
    return `${basePath()}${fromQuery}`
  }

  return withBase("/agro/dashboard")
}

const Login = ({ location }) => {
  const logo = useStore(state => state.logo)
  const reset = userStore(state => state.reset)
  const cleanError = toastHandler(state => state.cleanError)
  const cleanWarnings = toastHandler(state => state.cleanWarnings)

  const [error, setError] = useState("")
  const [loading, setLoading] = useState(false)

  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      name: "",
      password: "",
    },
    validationSchema: Yup.object({
      name: Yup.string().required("Por favor ingrese su nombre de usuario"),
      password: Yup.string().required("Por favor ingrese su contraseña"),
    }),
    onSubmit: values => {
      cleanError()
      cleanWarnings()
      setLoading(true)

      loginUser(values)
        .then(response => {
          setToken(response)
          // BDSJEA-129: si entro con una clave provisoria, va derecho a
          // cambiarla. El backend igual le va a rechazar todo lo demas.
          if (response.debeCambiarClave) {
            window.location.href = withBase("/cambiar-clave")
            return
          }
          // resolveRedirectPath ya devuelve el path con el prefijo de base
          window.location.href = resolveRedirectPath(location)
        })
        .catch(err => {
          setError(err.message)
          setLoading(false)
        })
    },
  })

  useEffect(() => {
    setError("")
  }, [validation.values.name, validation.values.password])

  useEffect(() => {
    reset()
  }, [])

  // BDSJEA-130: si hubiera chequeado solo getToken(), un token vencido o de
  // otro ambiente hacia que esta pantalla rebotara al dashboard en vez de
  // dejar entrar al login -- exactamente el bloqueo que reporta el ticket.
  if (isTokenValid()) {
    return <Redirect to={stripBase(resolveRedirectPath(location))} />
  }

  return (
    <React.Fragment>
      <MetaTags>
        <title>Iniciar sesión | EWAN</title>
      </MetaTags>
      <div className="home-btn d-none d-sm-block">
        <Link to="/" className="text-dark">
          <i className="fas fa-home h2" />
        </Link>
      </div>
      <div className="account-pages my-5 pt-sm-5">
        <Container>
          <Row className="justify-content-center">
            <Col md={8} lg={6} xl={5}>
              <Card className="overflow-hidden">
                <div className="bg-primary bg-soft">
                  <Row>
                    <Col xs={7}>
                      <div className="text-primary p-4">
                        <h5 className="text-primary">¡Bienvenido!</h5>
                        <p>Inicia sesión para continuar.</p>
                      </div>
                    </Col>
                    <Col className="col-5 align-self-end">
                      <img src={illustration} alt="" className="img-fluid" />
                    </Col>
                  </Row>
                </div>
                <CardBody className="pt-0">
                  <div>
                    <div className="avatar-md profile-user-wid mb-4">
                      <span className="avatar-title rounded-circle bg-white">
                        <img
                          src={`data:image/jpeg;base64,${logo.sm}`}
                          alt=""
                          className="rounded-circle"
                          height="75"
                        />
                      </span>
                    </div>
                  </div>
                  <div className="p-2">
                    <Form
                      className="form-horizontal"
                      onSubmit={e => {
                        e.preventDefault()
                        validation.handleSubmit()
                        return false
                      }}
                    >
                      {error !== "" ? (
                        <Alert color="danger">{error}</Alert>
                      ) : null}

                      <div className="mb-3">
                        <Label className="form-label">Usuario</Label>
                        <Input
                          name="name"
                          className="form-control"
                          placeholder="Ingrese su nombre de usuario"
                          type="name"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.name || ""}
                          invalid={
                            validation.touched.name && validation.errors.name
                              ? true
                              : false
                          }
                        />
                        {validation.touched.name && validation.errors.name ? (
                          <FormFeedback type="invalid">
                            {validation.errors.name}
                          </FormFeedback>
                        ) : null}
                      </div>

                      <div className="mb-3">
                        <Label className="form-label">Contraseña</Label>
                        <PasswordInput
                          name="password"
                          value={validation.values.password || ""}
                          placeholder="Ingrese su contraseña"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          invalid={
                            validation.touched.password &&
                            validation.errors.password
                              ? true
                              : false
                          }
                        />
                        {validation.touched.password &&
                        validation.errors.password ? (
                          <FormFeedback
                            type="invalid"
                            style={{ display: "block" }}
                          >
                            {validation.errors.password}
                          </FormFeedback>
                        ) : null}
                      </div>

                      <div className="mt-4 d-grid">
                        <button
                          className="btn btn-primary btn-block"
                          type="submit"
                          disabled={loading}
                        >
                          {loading ? (
                            <>
                              <Spinner size="sm" className="me-2" />
                              Ingresando...
                            </>
                          ) : (
                            "Ingresar"
                          )}
                        </button>
                      </div>
                    </Form>
                  </div>
                </CardBody>
                <div className="d-flex justify-content-between align-items-center font-size-10 me-1 ms-1 mb-1">
                  <Link to="/estado-servicios" className="text-muted">
                    Ver estado de los servicios
                  </Link>
                  <span>Ewan - {formatVersionLabel(metadata)}</span>
                </div>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default withRouter(Login)
